import axios from "axios";

export default {
  strict: true,
  namespaced: true,
  state: {
    roles: null,
  },
  getters: {
    roles: (state) => state.roles,
    // predictile
    isPredictile: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.roles["predictile"].length > 0,
    isPredictileAdministrator: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator"]),
    isPredictileManagement: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management"]),
    isPredictileOperations: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management", "predictile_operations"]),
    // business
    isBusinessAdministrator: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator"]),
    isBusinessManagement: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management"]),
    isBusinessOperations: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management", "business_operations"]),
    // common
    hasRole: (state) => (organizationId, roles) => {
      var hasAny = false;
      if (state.roles && state.roles[organizationId]) {
        for (let i = 0; i < roles.length; i++) {
          hasAny = hasAny || state.roles[organizationId].indexOf(roles[i]) > -1;
        }
      }
      return hasAny;
    },
    isLocationFiltered: (state, getters, rootState, rootGetters) => {
      var locations = rootGetters["location/locations"];
      var isFiltered = false;

      if (rootGetters["organization/organization"].type === "business") {
        for (let i = 0; i < locations.length; i++) {
          for (const currentRole in getters.roles) {
            if (currentRole === locations[i].businessLocationId) isFiltered = true;
          }
        }
      }
      return isFiltered;
    },
  },
  mutations: {
    setRoles(state, payload) {
      state.roles = payload;
    },
  },
  actions: {
    init: async (context) => {
      // is authenticated
      if (!context.rootGetters["cognito/isAuthenticated"]) {
        context.commit("setRoles", null);
        return;
      }

      // roles
      await axios
        .get(`/users/self/roles`)
        .then((res) => {
          var map = {};
          for (let i = 0; i < res.data.length; i++) {
            var role = res.data[i];
            map[role.entityId] = role.roles;
          }
          context.commit("setRoles", map);
          return Promise.resolve();
        })
        .catch(() => {});
    },
    clearRoles: async (context) => {
      context.commit("setRoles", null);
    },
  },
};
